import { DateTime } from 'luxon';
import { Opaque } from 'type-fest';

export type GqlIsoDateTime = Opaque<string, 'GqlIsoDateTime'>;

export function formatGqlIsoDateTime(value: Date): GqlIsoDateTime;
export function formatGqlIsoDateTime(value?: Date | undefined): GqlIsoDateTime | undefined;
export function formatGqlIsoDateTime(value?: Date): GqlIsoDateTime | undefined {
  if (typeof value === 'undefined') return;

  return DateTime.fromJSDate(value).toISO() as GqlIsoDateTime;
}

export function parseGqlIsoDateTime(value: GqlIsoDateTime): Date;
export function parseGqlIsoDateTime(value: string): Date;
export function parseGqlIsoDateTime(value?: GqlIsoDateTime | null): Date | undefined;
export function parseGqlIsoDateTime(value?: string | GqlIsoDateTime | null): Date | undefined {
  if (!value) return;

  const parsedDate = DateTime.fromISO(value);
  if (!parsedDate.isValid) {
    throw new Error('Invalid DateTime');
  }

  return parsedDate.toJSDate();
}
